<template>
    <div class="progressbar">
        <div class="bar" :style="{ transform: `scaleX(${percentage/100})`, '-ms-transform': `scaleX(${percentage/100})` }"></div>
    </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    percentage: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style lang="scss">
    .progressbar {
        position: relative;
        display: block;
        width: 100%;
        height: 6px;
        border-radius: 3px;
        overflow: hidden;
        background-color: lighten($brand-colour-primary, 45%);
        > .bar {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            background-color: $brand-colour-primary;
            width: 100%;
            -ms-transform: scaleX(0);
            -ms-transform-origin: 0 0;
            transform: scaleX(0);
            transform-origin: 0 0;
            transition: transform 300ms ease;
        }
    }
</style>
